/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIGuestUserRequest } from './APIGuestUserRequest';
import {
    APIGuestUserRequestFromJSON,
    APIGuestUserRequestFromJSONTyped,
    APIGuestUserRequestToJSON,
} from './APIGuestUserRequest';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIFeedbackSubmissionRequest
 */
export interface APIFeedbackSubmissionRequest {
    /**
     * The submission for feedback_form decoded as s JSON string.
     * @type {{ [key: string]: any; }}
     * @memberof APIFeedbackSubmissionRequest
     */
    submission: { [key: string]: any; };
    /**
     * 
     * @type {Date}
     * @memberof APIFeedbackSubmissionRequest
     */
    readAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIFeedbackSubmissionRequest
     */
    article: string;
    /**
     * 
     * @type {string}
     * @memberof APIFeedbackSubmissionRequest
     */
    feedbackForm: string;
    /**
     * 
     * @type {APIGuestUserRequest}
     * @memberof APIFeedbackSubmissionRequest
     */
    submittedBy: APIGuestUserRequest;
}

/**
 * Check if a given object implements the APIFeedbackSubmissionRequest interface.
 */
export function instanceOfAPIFeedbackSubmissionRequest(value: object): value is APIFeedbackSubmissionRequest {
    if (!('submission' in value) || value['submission'] === undefined) return false;
    if (!('article' in value) || value['article'] === undefined) return false;
    if (!('feedbackForm' in value) || value['feedbackForm'] === undefined) return false;
    if (!('submittedBy' in value) || value['submittedBy'] === undefined) return false;
    return true;
}

export function APIFeedbackSubmissionRequestFromJSON(json: any): APIFeedbackSubmissionRequest {
    return APIFeedbackSubmissionRequestFromJSONTyped(json, false);
}

export function APIFeedbackSubmissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIFeedbackSubmissionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'submission': json['submission'],
        'readAt': json['read_at'] == null ? undefined : (new Date(json['read_at'])),
        'article': json['article'],
        'feedbackForm': json['feedback_form'],
        'submittedBy': APIGuestUserRequestFromJSON(json['submitted_by']),
    };
}

export function APIFeedbackSubmissionRequestToJSON(value?: APIFeedbackSubmissionRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'submission': value['submission'],
        'read_at': value['readAt'] == null ? undefined : ((value['readAt'] as any).toISOString()),
        'article': value['article'],
        'feedback_form': value['feedbackForm'],
        'submitted_by': APIGuestUserRequestToJSON(value['submittedBy']),
    };
}

